export enum ActivityRound {
    MORNING = 'MORNING',
    AFTERNOON = 'AFTERNOON'
}
